/* =========================================================================
   assets/marquee.js
   Faixa horizontal infinita da coleção (mobile).
   Porta o loop em requestAnimationFrame do TheraMarquee.tsx.
   ========================================================================= */

class FeaMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.fea-marquee__track');
    if (!this.track) return;

    this.speed = parseFloat(this.dataset.speed || '0.35'); // px por frame
    this.offset = 0;
    this.paused = false;

    /* Duplica o conteúdo para que o loop nunca mostre vazio. */
    this.track.innerHTML += this.track.innerHTML;
    this.half = this.track.scrollWidth / 2;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.addEventListener('pointerenter', () => (this.paused = true));
    this.addEventListener('pointerleave', () => (this.paused = false));

    this.observer = new IntersectionObserver((entries) => {
      this.visible = entries[0].isIntersecting;
    });
    this.observer.observe(this);

    this.tick = this.tick.bind(this);
    this.raf = requestAnimationFrame(this.tick);
  }

  tick() {
    if (!this.paused && this.visible !== false) {
      this.offset -= this.speed;
      if (Math.abs(this.offset) >= this.half) this.offset = 0;
      this.track.style.transform = `translate3d(${this.offset}px,0,0)`;
    }
    this.raf = requestAnimationFrame(this.tick);
  }

  disconnectedCallback() {
    cancelAnimationFrame(this.raf);
    if (this.observer) this.observer.disconnect();
  }
}
customElements.define('fea-marquee', FeaMarquee);
